/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ODATA_CONFIG } from "@ui-kit/odata";
import { AppSettings } from "./appsettings/appsettings";
import { environment } from "./environments/environment";
import { enableProdMode } from "@angular/core";

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


fetch("/appsettings.json")
  .then((res) => res.json())
  .then((config: AppSettings) => {
    if (environment.production) {
      enableProdMode();
    }

    // let openIdConfiguration: OpenIdConfiguration = Object.assign({}, config.openIdConfiguration, environment.identityConfig);

    // openIdConfiguration.secureRoutes = [];
    // Object.keys(config.resources).forEach((key: string) => {
    //   openIdConfiguration.secureRoutes!.push(config.resources[key]);
    // });

    // localStorage.setItem("openIdConfiguration", JSON.stringify(openIdConfiguration));
    return config;
  })
  .then((config: AppSettings) => {
    platformBrowserDynamic([
      { provide: ODATA_CONFIG, useValue: { host: config.resources.core_api, routePrefix: environment.odataRoutePrefix } },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });